require('angular')
FlashService = require('./flash-service')

modules = []
angular.module 'gnp-flash', modules
  .factory 'flash', FlashService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/flash/flash-module.coffee